/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Allow_Overlap_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Toggle Allow Overlap" |
*
* @param {Timeline_Allow_Overlap_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_allow_overlap_aria_label = /** @type {((inputs?: Timeline_Allow_Overlap_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Allow_Overlap_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activer/désactiver le chevauchement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Überlappung zulassen/einschalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva/disattiva la sovrapposizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разрешить перекрытие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activar/desactivar la superposición")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换允许重叠")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーバーラップを許可する切り替え")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओवरलैप की अनुमति दें टॉगल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alternar Permitir Sobreposição")
	return /** @type {LocalizedString} */ ("Toggle Allow Overlap")
});